import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLoader from 'src/components/PageLoader';
import {
  PurchaseFlowAlreadyPurchasedGuard,
  PurchaseFlowMissingDataGuard,
} from 'src/components/PurchaseFlowGuards';
import { FeatureFlag } from 'src/constants/feature-flag';
import { ROUTES } from 'src/constants/routes';
import useGetFeatureFlag from 'src/helpers/hooks/useGetFeatureFlag';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';
import { useMount } from 'src/helpers/hooks/useMount';
import RentersInsuranceLayout from 'src/layouts/RentersInsuranceLayout';
import PaymentMsiV1 from 'src/pages/payment-msi/PaymentMsiV1/PaymentMsiV1';
import { PaymentMsiV2Loader } from 'src/pages/payment-msi/PaymentMsiV2/PaymentMsiV2Loader';
import { PaymentV2Layout } from 'src/pages/payment-msi/PaymentMsiV2/layouts';
import { PaymentLayoutProvider } from 'src/pages/payment-msi/PaymentMsiV2/providers';

const PaymentMSIContainer = () => {
  const navigate = useNavigate();
  const getUrlWithQueryParams = useLocationSearch();

  const { getFeatureFlag } = useGetFeatureFlag();
  const [isLoading, setIsLoading] = useState(true);
  const [ren3614NewPaymentWidgetFF, setRen3614NewPaymentWidgetFF] =
    useState(false);

  useMount(() => {
    getFeatureFlag(FeatureFlag.ren3614NewPaymentWidget)
      .then((featureFlag) => {
        setRen3614NewPaymentWidgetFF(featureFlag);
      })
      .finally(() => {
        setIsLoading(false);
      });
  });

  if (isLoading) {
    return <PageLoader />;
  }

  function onBack() {
    navigate(getUrlWithQueryParams(ROUTES.COVERAGES_DETAIL_PATH));
  }

  if (!ren3614NewPaymentWidgetFF) {
    return (
      <RentersInsuranceLayout
        footerProps={{ withMarginTop: true }}
        headerProps={{
          backButtonAction: onBack,
        }}
      >
        <PurchaseFlowAlreadyPurchasedGuard>
          <PurchaseFlowMissingDataGuard currentRoute={ROUTES.PAYMENT_PATH}>
            <PaymentMsiV1 />
          </PurchaseFlowMissingDataGuard>
        </PurchaseFlowAlreadyPurchasedGuard>
      </RentersInsuranceLayout>
    );
  }

  return (
    <PaymentLayoutProvider>
      <PaymentV2Layout>
        <PurchaseFlowAlreadyPurchasedGuard>
          <PurchaseFlowMissingDataGuard currentRoute={ROUTES.PAYMENT_PATH}>
            <PaymentMsiV2Loader />
          </PurchaseFlowMissingDataGuard>
        </PurchaseFlowAlreadyPurchasedGuard>
      </PaymentV2Layout>
    </PaymentLayoutProvider>
  );
};

export default PaymentMSIContainer;
